import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IUserCard } from '@app/classrooms/_components/classroom-user-card';
import { AccountService } from '@app/core/services';
import { ClassroomParticipant, MeetingAcceptStatusEnum, User } from 'lingo2-models';

@Component({
  selector: 'app-classroom-participant-card',
  templateUrl: './classroom-participant-card.component.html',
  styleUrls: ['./classroom-participant-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClassroomParticipantCardComponent {
  @Input() participant: ClassroomParticipant;
  @Input() isInvited: boolean;
  @Output() exclude = new EventEmitter<ClassroomParticipant>();

  public get userCard(): IUserCard {
    const user: User = this.participant && this.participant.user;
    const { id, userpic_id, country } = user || {};
    const fullName = AccountService.getUserFullName(user);
    return {
      id,
      userpic_id,
      title: fullName,
      description: country && country.title,
    };
  }

  public statusName(acceptStatus: MeetingAcceptStatusEnum): string {
    return MeetingAcceptStatusEnum[acceptStatus];
  }

  public onExclude(): void {
    this.exclude.emit(this.participant);
  }
}
